import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import '../../HTMLIntro.css'; // Reusing the same CSS file

const PHPCourseOutline = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const courseSections = [
    { id: 'history', title: 'History and Purpose of PHP', path: '/php-history-and-purpose-of-php' },
    { id: 'xampp', title: 'How to Install XAMPP', path: '/php-how-to-install-xampp' },
    { id: 'syntax', title: 'PHP Syntax', path: '/php-syntax' },
    { id: 'variables', title: 'Declaring Variables', path: '/php-declaring-variables' },
    { id: 'scope', title: 'Variable Scope', path: '/php-variable-scope' },
    { id: 'comments', title: 'Comments', path: '/php-comments' },
    { id: 'operators', title: 'PHP Operators', path: '/php-operators' },
    { id: 'functions', title: 'Functions', path: '/php-functions' },
    { id: 'if-else', title: 'If Else-Statement', path: '/php-if-else-statement' },
    { id: 'data-types', title: 'Data Types', path: '/php-data-types' },
    { id: 'loop', title: 'Loop', path: '/php-loop' },
    { id: 'switch', title: 'Switch Statement', path: '/php-switch-statement' },
    { id: 'array', title: 'Arrays in PHP', path: '/php-array' },
    { id: 'arrays', title: 'Arrays in PHP', path: '/php-arrays' }, // Note: Duplicate title, different path
    { id: 'database-setup', title: 'MySQL Database Setup', path: '/php-database-setup' },
    { id: 'create-table', title: 'Create a Table', path: '/php-create-table' },
    { id: 'connect-db', title: 'Connect to Database', path: '/php-connect-database' },
    { id: 'crud', title: 'What is CRUD?', path: '/php-what-crud-operations' },
    { id: 'crud-illustration', title: 'CRUD Illustration', path: '/php-crud' }
  ];

  return (
    <HTMLCourseNavProvider>
      <div className="modern-course-container">
        <SideBar />
        
        <div className="course-content">
          <div className="course-header">
            <h1 className="course-title">PHP Course</h1>
            <p className="course-subtitle">Master server-side scripting and dynamic web development</p>
            <div className="progress-container">
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: '0%' }}></div>
              </div>
              <span className="progress-text">0% Complete</span>
            </div>
          </div>

          <div className="course-outline-card">
            <div className="card-header">
              <h2 className="card-title">
                <i className="fab fa-php me-2"></i>
                Course Outline
              </h2>
              <span className="lesson-count">{courseSections.length} lessons</span>
            </div>

            <div className="lessons-container">
              {courseSections.map((section, index) => (
                <div key={section.id} className="lesson-section">
                  <div 
                    className={`lesson-item ${expandedSections[section.id] ? 'expanded' : ''}`}
                    onClick={() => section.sublessons && toggleSection(section.id)}
                  >
                    <div className="lesson-number">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    
                    <div className="lesson-content">
                      <Link 
                        to={section.path} 
                        className="lesson-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {section.title}
                      </Link>
                      
                      {section.sublessons && (
                        <button className="expand-btn">
                          <i className={`fas fa-chevron-${expandedSections[section.id] ? 'up' : 'down'}`}></i>
                        </button>
                      )}
                    </div>

                    <div className="lesson-status">
                      <span className="status-badge">Start</span>
                    </div>
                  </div>

                  {section.sublessons && expandedSections[section.id] && (
                    <div className="sublessons-container">
                      {section.sublessons.map((sublesson, subIndex) => (
                        <Link 
                          key={subIndex} 
                          to={sublesson.path} 
                          className="sublesson-item"
                        >
                          <div className="sublesson-number">
                            {index + 1}.{subIndex + 1}
                          </div>
                          <span className="sublesson-title">{sublesson.title}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="card-footer">
              <button className="start-course-btn">
                <i className="fas fa-server me-2"></i>
                Start PHP Development
              </button>
            </div>
          </div>
        </div>
      </div>
    </HTMLCourseNavProvider>
  );
};

export default PHPCourseOutline;